import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cetf-cookie-consent")) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("cetf-cookie-consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-5" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-fade-up">
        <p className="text-sm text-slate-600 leading-relaxed flex-1">
          <strong className="text-slate-800">Respect de votre vie privée.</strong>{" "}
          Ce site utilise uniquement des cookies techniques nécessaires à la connexion
          de votre espace adhérent. Aucun cookie publicitaire ni mesure d'audience.
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <Button variant="outline" size="sm" className="flex-1 sm:flex-none" onClick={() => choose("none")} data-testid="cookie-refuse-btn">
            Tout refuser
          </Button>
          <Button size="sm" className="flex-1 sm:flex-none bg-emerald-600 hover:bg-emerald-700" onClick={() => choose("all")} data-testid="cookie-accept-btn">
            Tout accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
